import { Chip } from "@mui/material";

interface EstateTypeProps {
  type: string;
}

export default function EstateType({ type }: EstateTypeProps) {
  return <Chip label={type} color="secondary" />;
}
